// extracted by mini-css-extract-plugin
export default {"column":"styles_column__yGtpt","fill":"styles_fill__EQsHe"};